var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard-premium"
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center flex-wrap",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('h2', {
    staticClass: "dashboard-title mb-50"
  }, [_vm._v("Flare Analytics Dashboard")]), _c('p', {
    staticClass: "dashboard-subtitle mb-0"
  }, [_vm._v("Executive overview of revenue, orders, funnel and customer activity")])]), _c('div', {
    staticClass: "d-flex align-items-center mt-1 mt-md-0"
  }, [_c('b-button-group', _vm._l(_vm.ranges, function (r) {
    return _c('b-button', {
      key: r.value,
      attrs: {
        "variant": _vm.selectedRange === r.value ? 'primary' : 'outline-primary'
      },
      on: {
        "click": function ($event) {
          return _vm.changeRange(r.value);
        }
      }
    }, [_vm._v(" " + _vm._s(r.label) + " ")]);
  }), 1)], 1)])], 1), _vm.loading ? _c('div', {
    staticClass: "loading-wrap"
  }, [_c('b-card', {
    staticClass: "premium-card"
  }, [_c('div', {
    staticClass: "text-center py-3"
  }, [_vm._v("Loading dashboard...")])])], 1) : [_c('b-row', _vm._l(_vm.statCards, function (card) {
    return _c('b-col', {
      key: card.key,
      attrs: {
        "xl": "3",
        "md": "6",
        "sm": "6"
      }
    }, [_c('b-card', {
      staticClass: "premium-card stat-card mb-2"
    }, [_c('div', [_c('div', {
      staticClass: "stat-label"
    }, [_vm._v(_vm._s(card.label))]), _c('div', {
      staticClass: "stat-value"
    }, [_vm._v(_vm._s(card.value))]), _c('div', {
      staticClass: "stat-meta"
    }, [_vm._v(_vm._s(card.meta))])])])], 1);
  }), 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2 live-card"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Live Visitors")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.number(_vm.liveVisitors.live_visitors || 0)))]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v("Active in last 2 minutes")])])])], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Product Views")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.number(_vm.funnelSummary.product_views || 0)))]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v(_vm._s(_vm.funnelSummary.view_to_cart_rate || 0) + "% to cart")])])])], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Add To Cart")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.number(_vm.funnelSummary.add_to_cart || 0)))]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v(_vm._s(_vm.funnelSummary.cart_to_checkout_rate || 0) + "% to checkout")])])])], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Checkout Starts")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.number(_vm.funnelSummary.checkout_starts || 0)))]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v(_vm._s(_vm.funnelSummary.checkout_to_purchase_rate || 0) + "% to purchase")])])])], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Purchases")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.number(_vm.funnelSummary.purchases || 0)))]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v("Completed orders")])])])], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "4",
      "md": "6",
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card stat-card mb-2 conversion-card"
  }, [_c('div', [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Conversion Rate")]), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.funnelSummary.overall_conversion_rate || 0) + "%")]), _c('div', {
    staticClass: "stat-meta"
  }, [_vm._v("View to purchase")])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "8",
      "lg": "7"
    }
  }, [_c('b-card', {
    staticClass: "premium-card chart-card mb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Revenue vs Orders")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Revenue uses left axis, orders use right axis")])]), _vm.revenueChart.length ? _c('div', [_c('apexchart', {
    attrs: {
      "type": "line",
      "height": "330",
      "options": _vm.revenueChartOptions,
      "series": _vm.revenueSeries
    }
  })], 1) : _c('div', {
    staticClass: "empty-wrap"
  }, [_vm._v("No chart data found")])])], 1), _c('b-col', {
    attrs: {
      "xl": "4",
      "lg": "5"
    }
  }, [_c('b-card', {
    staticClass: "premium-card chart-card mb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Order Status Breakdown")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Top statuses grouped for clean view")])]), _vm.statusSeries.length ? _c('div', [_c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "330",
      "options": _vm.statusChartOptions,
      "series": _vm.statusSeries
    }
  })], 1) : _c('div', {
    staticClass: "empty-wrap"
  }, [_vm._v("No status data found")])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Top Customers")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Highest spenders by delivered revenue")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Phone")]), _c('th', [_vm._v("Orders")]), _c('th', [_vm._v("Spent")])])]), _c('tbody', [_vm._l(_vm.topCustomers, function (c) {
    return _c('tr', {
      key: c.id
    }, [_c('td', [_vm._v(_vm._s(c.full_name || 'N/A'))]), _c('td', [_vm._v(_vm._s(c.phone || 'N/A'))]), _c('td', [_vm._v(_vm._s(_vm.number(c.total_orders)))]), _c('td', [_vm._v(_vm._s(_vm.money(c.total_spent)))])]);
  }), !_vm.topCustomers.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No customer data found")])]) : _vm._e()], 2)])])])], 1), _c('b-col', {
    attrs: {
      "xl": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Recent Orders")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Latest order flow snapshot")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Order ID")]), _c('th', [_vm._v("Customer")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Total")])])]), _c('tbody', [_vm._l(_vm.recentOrders, function (o) {
    return _c('tr', {
      key: o.id
    }, [_c('td', [_vm._v("#" + _vm._s(o.large_order_id || o.id))]), _c('td', [_vm._v(_vm._s(o.full_name || 'N/A'))]), _c('td', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": _vm.statusVariant(o.status)
      }
    }, [_vm._v(" " + _vm._s(o.status) + " ")])], 1), _c('td', [_vm._v(_vm._s(_vm.money(o.total_price)))])]);
  }), !_vm.recentOrders.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No order data found")])]) : _vm._e()], 2)])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Top Selling Products")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Best selling products in selected range")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _c('th', [_vm._v("Orders")]), _c('th', [_vm._v("Qty")]), _c('th', [_vm._v("Revenue")])])]), _c('tbody', [_vm._l(_vm.topSellingProducts, function (item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('div', {
      staticClass: "product-cell"
    }, [_c('img', {
      staticClass: "product-thumb",
      attrs: {
        "src": _vm.productImage(item),
        "alt": "Product"
      },
      on: {
        "error": _vm.onImageError
      }
    }), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(_vm.cleanProductName(item.name)))])])])]), _c('td', [_vm._v(_vm._s(_vm.number(item.total_orders)))]), _c('td', [_vm._v(_vm._s(_vm.number(item.total_qty)))]), _c('td', [_vm._v(_vm._s(_vm.money(item.revenue)))])]);
  }), !_vm.topSellingProducts.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No product sales data found")])]) : _vm._e()], 2)])])])], 1), _c('b-col', {
    attrs: {
      "xl": "6"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Low Conversion Products")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Products with views but weak add-to-cart rate")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _c('th', [_vm._v("Views")]), _c('th', [_vm._v("Add To Cart")]), _c('th', [_vm._v("Rate")])])]), _c('tbody', [_vm._l(_vm.lowConversionProducts, function (item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('div', {
      staticClass: "product-cell"
    }, [_c('img', {
      staticClass: "product-thumb",
      attrs: {
        "src": _vm.productImage(item),
        "alt": "Product"
      },
      on: {
        "error": _vm.onImageError
      }
    }), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(_vm.cleanProductName(item.name)))])])])]), _c('td', [_vm._v(_vm._s(_vm.number(item.product_views)))]), _c('td', [_vm._v(_vm._s(_vm.number(item.add_to_cart)))]), _c('td', [_vm._v(_vm._s(item.add_to_cart_rate) + "%")])]);
  }), !_vm.lowConversionProducts.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No conversion data found")])]) : _vm._e()], 2)])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "12"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2 flex-wrap"
  }, [_c('div', [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Current Page Viewers")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Live active visitors by current page")])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Updated " + _vm._s(_vm.liveUpdatedText) + " ")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Page")]), _c('th', [_vm._v("Viewers")])])]), _c('tbody', [_vm._l(_vm.currentPageViewers, function (item, index) {
    return _c('tr', {
      key: ((item.current_page) + "-" + index)
    }, [_c('td', [_vm._v(_vm._s(item.current_page || '/'))]), _c('td', [_vm._v(_vm._s(_vm.number(item.viewers)))])]);
  }), !_vm.currentPageViewers.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No active page viewers found")])]) : _vm._e()], 2)])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "12"
    }
  }, [_c('b-card', {
    staticClass: "premium-card mb-2 table-card"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Delivery Split")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Inside Dhaka / Outside Dhaka ratio, value and delivery charge")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table premium-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Zone")]), _c('th', [_vm._v("Orders")]), _c('th', [_vm._v("Total Amount")]), _c('th', [_vm._v("Delivery Charge")]), _c('th', [_vm._v("Ratio")])])]), _c('tbody', [_vm._l(_vm.deliverySplit, function (item) {
    return _c('tr', {
      key: item.zone
    }, [_c('td', [_vm._v(_vm._s(item.zone || 'Unknown'))]), _c('td', [_vm._v(_vm._s(_vm.number(item.total_orders)))]), _c('td', [_vm._v(_vm._s(_vm.money(item.total_amount)))]), _c('td', [_vm._v(_vm._s(_vm.money(item.total_delivery_charge)))]), _c('td', [_vm._v(_vm._s(item.ratio) + "%")])]);
  }), !_vm.deliverySplit.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No delivery split data found")])]) : _vm._e()], 2)])])])], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }